import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Mail, Home } from "lucide-react";

export default function Confirmation() {
    const { caseNumber } = useParams();
    const [info, setInfo] = useState(null);

    useEffect(() => {
        api.get(`/public/complaints/by-number/${caseNumber}`).then((r) => setInfo(r.data)).catch(() => {});
    }, [caseNumber]);

    return (
        <div className="min-h-screen bg-[#FAFAF9] flex flex-col">
            <header className="border-b border-[#E5E1DA] bg-white">
                <div className="max-w-3xl mx-auto px-6 py-4">
                    <Logo to="/" size="sm" subtitle={null} />
                </div>
            </header>
            <main className="flex-1 flex items-center justify-center px-6 py-16">
                <div className="max-w-lg w-full bg-white border border-[#E5E1DA] rounded-2xl p-8 sm:p-12 text-center shadow-[0_8px_32px_rgba(44,42,41,0.04)]">
                    <div className="w-14 h-14 rounded-full bg-[#DCFCE7] mx-auto flex items-center justify-center mb-6">
                        <CheckCircle2 className="w-7 h-7 text-[#15803D]" />
                    </div>
                    <h1 className="font-heading text-3xl font-medium text-[#2C2A29] mb-3">Tak for din henvendelse</h1>
                    <p className="text-[#5C5854] leading-relaxed mb-8">
                        Vi har modtaget din reklamation. Du kan forvente at blive kontaktet inden for 1-3 hverdage.
                    </p>

                    <div className="bg-[color:var(--brand-accent-soft)] rounded-xl p-5 mb-6">
                        <div className="text-xs font-semibold uppercase tracking-wider text-[#78736E]">Dit sagsnummer</div>
                        <div
                            className="font-heading text-3xl font-semibold text-[color:var(--brand-accent-strong)] mt-1 tracking-wide"
                            data-testid="confirmation-case-number"
                        >
                            {caseNumber}
                        </div>
                    </div>

                    {info?.customer_email && (
                        <div className="flex items-center justify-center gap-2 text-sm text-[#78736E] mb-8">
                            <Mail className="w-4 h-4" />
                            En bekræftelse er sendt til {info.customer_email}
                        </div>
                    )}

                    <Link to="/">
                        <Button variant="outline" data-testid="confirmation-home-button" className="border-[#D2C9B9] hover:bg-[#F0EBE1]">
                            <Home className="w-4 h-4 mr-2" />
                            Tilbage til forside
                        </Button>
                    </Link>
                </div>
            </main>
        </div>
    );
}
